import React from 'react'
import { connect } from 'react-redux'
import { getFormValues, Field } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { GeneralContainer, Cont, SContDetail, SectionContainer } from './styled'
import { DataCell } from '../DataCell'
import { RowFields } from '../../styled'
import { StdCard } from 'components'

const PurchaseOrderGeneral = (props) => {
  const { valueForm } = props
  return (
    <StdCard title='General' style={{marginTop:'15px'}}>
      <GeneralContainer>
        <Cont>
          <RowFields>
            <Field
              name='goaItemName'
              label='PO GOA'
              type={type.text}
              component={FieldInput}
              editable={false}
            />
          </RowFields>
          <SContDetail>
            <SectionContainer>
              <div className='header'>Company Information</div>
              <div className='body'>
                <Cont>
                  <SContDetail>
                    <DataCell title='Company' value={valueForm.companyName}/>
                  </SContDetail>
                  <SContDetail>
                    <DataCell title='Bill Address' value={valueForm.companyAddress}/>
                  </SContDetail>
                  <SContDetail>
                    <DataCell title='Contact' value={valueForm.companyContact}/>
                  </SContDetail>
                  <SContDetail>
                    <DataCell title='Telephone' value={valueForm.companyTelephone}/>
                  </SContDetail>
                  <SContDetail>
                    <DataCell title='Reference PR No.' value={valueForm.prNumber}/>
                  </SContDetail>
                </Cont>
              </div>
            </SectionContainer>
            <SectionContainer>
              <div className='header'>Vendor Information</div>
              <div className='body'>
                <Cont>
                  <SContDetail>
                    <DataCell title='Vendor' value={valueForm.vendorName}/>
                  </SContDetail>
                  <SContDetail>
                    <DataCell title='Vendor Address' value={valueForm.vendorAddress}/>
                  </SContDetail>
                  <SContDetail>
                    <DataCell title='Contact' value={valueForm.vendorContact}/>
                  </SContDetail>
                  <SContDetail>
                    <DataCell title='Telephone' value={valueForm.vendorTelephone}/>
                  </SContDetail>
                  <SContDetail>
                    <DataCell title='Payment Term' value={valueForm.paymentTerm}/>
                  </SContDetail>
                </Cont>
              </div>
            </SectionContainer>
          </SContDetail>
        </Cont>
      </GeneralContainer>
    </StdCard>
  )
}

const mapStateToProps = (state) => ({
  valueForm : getFormValues('formPO')(state)||{}
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderGeneral)